var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNotification(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 21,
    viewBox: "0 0 22 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M21.2692 13.9523V17.4986H0.5V13.9523L2.83308 12.8913L4.86327 6.34557C5.19904 5.26038 6.20289 4.52047 7.33914 4.51874H14.431C15.5663 4.52047 16.5702 5.26038 16.906 6.34557L18.9362 12.8913L21.2692 13.9523ZM19.9712 16.2006V14.7883L18.3988 14.0726L17.8683 13.832L17.6961 13.2756L15.6667 6.73067C15.4971 6.18374 14.9987 5.81682 14.4266 5.81682H7.3426C6.77058 5.81682 6.27212 6.18374 6.1025 6.73067L4.07317 13.2756L3.90096 13.832L3.37048 14.0726L1.79808 14.7883V16.2006H19.9712ZM14.5898 18.7976C13.6532 19.6014 12.4475 20.0957 11.1152 20.0957C9.78281 20.0957 8.57715 19.6014 7.63942 18.7976H14.5898ZM7.63942 3.8697C7.63942 2.07743 9.09235 0.624512 10.8846 0.624512C12.6769 0.624512 14.1298 2.07743 14.1298 3.8697H12.8317C12.8317 2.79434 11.96 1.92259 10.8846 1.92259C9.80925 1.92259 8.9375 2.79434 8.9375 3.8697H7.63942Z",
    fill: "#303030"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNotification);
export default __webpack_public_path__ + "static/media/notification.5d2da974e9c7b80a513eae249395aceb.svg";
export { ForwardRef as ReactComponent };